import { CompatibleProducts } from '@atlassian/mpac-types';
import { AtlassianProductHostingType, MarketplaceAppPaymentModel } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
import React from 'react';
import { PurchaseIntent } from "../../../AppListing.types";
import HostingLicenseGuidanceText from "./hosting-license-guidance.text";
const HostingLicenseGuidanceCloud = _ref => {
  let {
    paymentModel,
    compatibleProducts,
    purchaseIntent,
    learnMoreUrl,
    isRemote,
    isNotAnApp
  } = _ref;
  const isBitbucketCompatible = compatibleProducts.some(product => product.id === CompatibleProducts.BITBUCKET);
  switch (paymentModel) {
    case MarketplaceAppPaymentModel.PaidViaAtlassian:
      return purchaseIntent === PurchaseIntent.TRY ? HostingLicenseGuidanceText.CLOUD_PVA_TRY : HostingLicenseGuidanceText.CLOUD_PVA_BUY;
    case MarketplaceAppPaymentModel.PaidViaPartner:
      {
        const isBundled = !isBitbucketCompatible;
        return isBundled ? HostingLicenseGuidanceText.CLOUD_PVV_PREINSTALLED(compatibleProducts) : HostingLicenseGuidanceText.CLOUD_PVV(learnMoreUrl);
      }
    case MarketplaceAppPaymentModel.Free:
      {
        const isCloudFreeRemoteable = isRemote || isBitbucketCompatible;
        const isPreinstalled = !isCloudFreeRemoteable && !isNotAnApp;
        return isPreinstalled ? HostingLicenseGuidanceText.CLOUD_FREE_PREINSTALLED(compatibleProducts) : HostingLicenseGuidanceText.CLOUD_FREE(compatibleProducts);
      }
    default:
      throw new Error('Unhandled payment method : ' + paymentModel);
  }
};
const HostingLicenseGuidanceServerDC = _ref2 => {
  let {
    paymentModel,
    compatibleProducts,
    purchaseIntent,
    hosting,
    isNotAnApp
  } = _ref2;
  switch (paymentModel) {
    case MarketplaceAppPaymentModel.PaidViaAtlassian:
      {
        const buyText = hosting === AtlassianProductHostingType.Server ? HostingLicenseGuidanceText.SERVER_PVA_BUY : HostingLicenseGuidanceText.DATACENTER_PVA_BUY;
        return purchaseIntent === PurchaseIntent.BUY ? buyText : HostingLicenseGuidanceText.SERVER_DATACENTER_PVA_TRY;
      }
    case MarketplaceAppPaymentModel.PaidViaPartner:
      return HostingLicenseGuidanceText.SERVER_DATACENTER_PVV;
    case MarketplaceAppPaymentModel.Free:
      return HostingLicenseGuidanceText.SERVER_DATACENTER_FREE(compatibleProducts, isNotAnApp, hosting);
    default:
      throw new Error('Unhandled payment type ' + paymentModel);
  }
};
const HostingLicenseGuidance = _ref3 => {
  let {
    paymentModel,
    compatibleProducts,
    hosting,
    learnMoreUrl,
    isNotAnApp,
    isRemote,
    purchaseIntent
  } = _ref3;
  switch (hosting) {
    case AtlassianProductHostingType.Server:
    case AtlassianProductHostingType.DataCenter:
      return /*#__PURE__*/React.createElement(HostingLicenseGuidanceServerDC, {
        paymentModel: paymentModel,
        isNotAnApp: isNotAnApp,
        hosting: hosting,
        compatibleProducts: compatibleProducts,
        purchaseIntent: purchaseIntent
      });
    case AtlassianProductHostingType.Cloud:
      return /*#__PURE__*/React.createElement(HostingLicenseGuidanceCloud, {
        purchaseIntent: purchaseIntent,
        compatibleProducts: compatibleProducts,
        isNotAnApp: isNotAnApp,
        paymentModel: paymentModel,
        isRemote: isRemote,
        learnMoreUrl: learnMoreUrl
      });
    default:
      throw new Error('Unhandled hosting type: ' + hosting);
  }
};
export default HostingLicenseGuidance;